import {path, split} from 'ramda'
import {ColorPath} from 'types/Theme'

import {cssTheme} from '../themes'

/**
 * Get the color from the theme based on the color path
 */

export const getCssColorByPath = (colorPath: ColorPath) => {
  return colorPath
    ? (path(split('.', colorPath), cssTheme.colors) as string)
    : undefined
}
